var $ = jQuery;
let menuItems = document.querySelectorAll('.header__inline-menu details'); // Adjust selector based on your theme
menuItems.forEach(item => {
  item.addEventListener('mouseover', () => {
    item.setAttribute('open', true);
  });
  item.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.marken-item > a[href^="#"]');
  for (let link of links) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const target = document.getElementById(targetId);
      if (target) {
        window.scrollTo({
          top: target.offsetTop - 190, // adjust if you have a sticky header
          behavior: 'smooth'
        });
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.getElementById('open-video');
  const popup = document.getElementById('video-popup');
  const closeBtn = document.getElementById('close-video');
  const video = document.getElementById('popup-video');

  if (!openBtn || !popup || !closeBtn || !video) {
   //console.warn('[Video Popup] Missing elements');
    return;
  } 
  openBtn.addEventListener('click', () => {
    popup.classList.remove('hidden');
    video.play();
  });

  closeBtn.addEventListener('click', () => {
    popup.classList.add('hidden');
    video.pause();
    video.currentTime = 0;
  });

  // Close by clicking background
  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.classList.add('hidden');
      video.pause();
      video.currentTime = 0;
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (!localStorage.getItem("popup_shown")) {
    // Show after 1 seconds
    setTimeout(function () {
      document.getElementById("custom-popup").style.display = "flex";
      localStorage.setItem("popup_shown", "true");
    }, 20000);
  }

  document.getElementById("close-popup").addEventListener("click", function () {
    document.getElementById("custom-popup").style.display = "none";
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form#ContactFooter');
  const checkbox = document.getElementById('agree-checkbox');

  if (form && checkbox) {
    form.addEventListener('submit', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        alert("Bitte bestätigen");
      }
    });
  }
});
jQuery(document).ready(function ($) {
  $('body').on('click', 'a[href="#show_phone"]', function (e) {
    e.preventDefault();
    $('ul.list-address').toggle();
  });
  var href = window.location.href;
  var hash = window.location.hash;
  // console.log(hash);
  if (href.includes("faq")) {
    if (hash.includes("#")) {
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 100 
      }, 'slow');
    }
  }
  $('.btn-link-back-category-custom').on('click', function () {
    // Scroll to the bottom of the section
    $('html, body').animate({
      scrollTop: $('product-info').offset().top + $('product-info').outerHeight() - 150
    }, 800); // 800ms smooth scroll
  });
  $('#NewsletterForm').on('submit', function (e) {
    e.preventDefault();

    var $form = $(this);
    var data = $form.serialize();
    var url = $form.attr('action');

    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      success: function (response) {
        $('#NewsletterMessage').css('color', '#000').fadeIn();
        $('#NewsletterMessage .success').css('display', 'block').fadeIn();
        $form[0].reset();
        $('#NewsletterForm .newsletter-form__field-wrapper').hide();
      },
      error: function () {
        $('#NewsletterMessage').css('color', '#red').fadeIn();
        $('#NewsletterMessage .error').css('display', 'block').fadeIn();
      }
    });
  });
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 0) {
      $('.announcement-bar-section').addClass('scrolled');
    } else {
      $('.announcement-bar-section').removeClass('scrolled');
    }
  });
  jQuery(function ($) {
    var $headers = $('.accordion-toggle'),
      $contents = $('.accordion-panel');

    // Optionally open the first section on load:
    $('.accordion-section:not(.faq-st) .accordion-toggle').first().addClass('active');
    $('.accordion-section:not(.faq-st) .accordion-panel').first().show();

    $headers.on('click', function () {
      var $h = $(this),
        $c = $h.next('.accordion-panel');

      if ($h.hasClass('active')) {
        // close this one
        $h.removeClass('active');
        $c.slideUp(300);
      } else {
        // close others
        $headers.filter('.active').removeClass('active')
          .next('.accordion-panel').slideUp(300);
        // open this one
        $h.addClass('active');
        $c.slideDown(300);
      }
    });
  });


  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
  });
  $('.scroll-box-collection').click(function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: $('.collections-breadcrumbs').offset().top - 50 }, 1000);
  });
  //slider mini cart
  //slider mini cart

  var swiper1 = new Swiper('.custom-slider-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-prev',
      prevEl: '.swiper-button-next',
    },
    wrapperClass: 'custom-slider-wrapper',
    slideClass: 'custom-slider-slide'
  });

  var swiper = new Swiper('.slider-upsell', {
    slidesPerView: 2,
    spaceBetween: 15,
    loop: true,
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.upsell_products .swiper-button-next',
      prevEl: '.upsell_products .swiper-button-prev',
    }
  });
  //slider mini cart
  
  
  $('.scroll-box > a').on('click', function () {
    var href = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $('span.scroll-to[data-link="' + href + '"]').offset().top - 80
    }, 1000); // 1000 ms = 1 second
  });
  $('.footer-block.has-dropdown h2.footer-block__heading').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
  });
});
//Swipper slider
$(document).ready(function () {
  ///// Tab Faq

    $('.trust-icon-faq').on('click', 'a.link-box[href^="#"]', function (e) {
    e.preventDefault();

    const $header = $('header'); // 
    const headerHeight = $header.outerHeight() || 0;

    const targetID = $(this).attr('href');
    const $target = $(targetID);

    if (!$target.length) return;

    const offsetTop =
      $target.offset().top - headerHeight - 65;

    $('html, body').stop().animate(
      { scrollTop: offsetTop },
      600,
      'swing'
    );
  });

  $(document).on('click', '.acctab_title', function (e) {
    if ($(window).width() >= 768) {
      $('.acctab_title').removeClass('active-accor');
      $(this).addClass('active-accor');
      $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
    } else {
      $('.acctab_title').removeClass('active-accor');
      $(this).addClass('active-accor');
      $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
      // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
    }
  });
  $(document).on('click', '.acc_tab-inner .acc-tab-content .back__arrow', function (e) {
    $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });
  ///// Tab Faq



$(document).on('click', '.js-show-more-variants', function(e) {
      e.preventDefault();
      $('.collapsed').removeClass('collapsed');
      $(this).hide(); 
    });
  // $('slideshow-component.show_loading').mousemove(function (e) {
  //   $('.cursor-progress')
  //     .eq(0)
  //     .css({
  //       left: e.pageX,
  //       top: e.pageY,
  //     });
  //   $('.cursor')
  //     .eq(0)
  //     .css({
  //       left: e.pageX,
  //       top: e.pageY,
  //     });
  //   $('.cursor')
  //     .eq(1)
  //     .css({
  //       left: e.pageX,
  //       top: e.pageY,
  //     });
  //   var $targetElement = $(e.target);
  // });
  $('slideshow-component.show_loading').mouseout(function () {
    // $('.cursor, .cursor-progress').hide();
  });
});



function initCardSlider() {
  $('.card__media_sl').each(function () {
    var $this = $(this);
    if ($this.find('> div').length > 1 && !$this.hasClass('flickity-enabled')) {
      $this.flickity({
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        cellAlign: 'left',
        autoPlay: false
      });
    }
  });
}

$(document).ready(function () {
  initCardSlider();
});

$(document).on('shopify:section:load shopify:section:reorder facets:updated', function () {
  initCardSlider();
});
const target = document.querySelector('#main-collection-product-grid, #ProductGridContainer, #main-grid');
if (target) {
  new MutationObserver(function (mutations) {
    initCardSlider();
  }).observe(target, { childList: true, subtree: true });
}


$('.cart-item').each(function () {
  const $item = $(this);
  $item.append(`
    <div class="lightbox-popup" style="
        display:none;
        position: fixed;
        top: 0; left: 0;
        width: 100%; height: 100%;
        background: rgba(0,0,0,0.7);
        justify-content: center;
        align-items: center;
        z-index: 9999;
    ">
      <span class="lightbox-close" 
        style="
          position:absolute;
          top:20px; right:30px;
          font-size:40px;
          color:#fff;
          cursor:pointer;
        ">&times;</span>

      <img class="lightbox-img" src="" alt=""
        style="max-width:90%; max-height:90%; border-radius:8px;">
    </div>
  `);


  $item.find('.cart-item__image').on('click', function () {
    const src = $(this).attr('src');
    $item.find('.lightbox-img').attr('src', src);
    $item.find('.lightbox-popup')
      .fadeIn(200)
      .css("display", "flex");
  });

 
  $item.find('.lightbox-close').on('click', function () {
    $item.find('.lightbox-popup').fadeOut(200);
  });


  $item.find('.lightbox-popup').on('click', function (e) {
    if (e.target === this) {
      $(this).fadeOut(200);
    }
  });
});


class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

window.customElements.define("price-range1", PriceRange1);

  function formatMoney(cents) {
    // return (cents / 100).toFixed(2).toLocaleString('de-DE') + '€\u00A0';
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }
$(document).on('change', '.select__select', function () {
  
  var $select = $(this);
  var $productItem = $select.closest('.pdp_detail');
  var newImage = $(this).find('option:selected').attr('data-image'); 
  $productItem.find('.pdp-img-crspdp').attr('src', newImage);
  var selectedOptions = [];

  $productItem.find('.select__select').each(function () {
    selectedOptions.push($(this).val());
  });

  var variants = JSON.parse($productItem.attr('data-variants'));

  var matchedVariant = variants.find(function (variant) {
    return variant.options.every(function (opt, index) {
      return opt === selectedOptions[index];
    });
  });

  if (matchedVariant) {
    var $priceContainer = $productItem.find('.price-custom');
    var priceHtml = '';

    if (matchedVariant.compare_at_price > matchedVariant.price) {
     
      priceHtml += '<span class="sale-price">' + formatMoney(matchedVariant.price) + '</span>';
      priceHtml += '<span class="original-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
      priceHtml += '<span class="du-sparst">Du sparst ' + formatMoney(matchedVariant.compare_at_price - matchedVariant.price) + '</span>';
    } else {
      priceHtml += '<span class="regular-price">' + formatMoney(matchedVariant.price) + '</span>';
    }
    // priceHtml = priceHtml.replace("€", ' €')
    $priceContainer.html(priceHtml);

    $productItem.find('.product-variant-id').val(matchedVariant.id);
    var $btn = $productItem.find('button[type="submit"]');
    if (matchedVariant.available) {
      $btn.prop('disabled', false);
    } else {
      $btn.prop('disabled', true);
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.querySelector('.preis-popup-open');
  const popup = document.querySelector('.preis-popup');
  const closeBtn = document.querySelector('.preis-popup__close');
  const overlay = document.querySelector('.preis-popup__overlay');

  if (!openBtn || !popup) return;

  openBtn.addEventListener('click', function () {
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  });

  function closePopup() {
    popup.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  closeBtn?.addEventListener('click', closePopup);
  overlay?.addEventListener('click', closePopup);
});